var FormErrorsMixin = {
    data() {
        return {
            errors: {},
        }
    },

    methods: {
        /**
         * Check if given input has error.
         * @param  string input
         * @return bool
         */
        hasError(input) {
            return this.isAllowedInput(input)
                && typeof this.errors[input] !== 'undefined'
                && this.errors[input].length > 0
            ;
        },

        /**
         * Return error of given input.
         * @param  input
         * @return string
         */
        getError(input) {
            if (!this.isAllowedInput(input) || !this.hasError(input)) {
                return '';
            }

            return this.errors[input][0];
        },

        /**
         * Store errors.
         * @param  array errors
         */
        storeErrors(errors) {
            var successfulStored = false;

            for (var key in errors) {
                if (errors.hasOwnProperty(key)) {
                    successfulStored = true;
                    break;
                }
            }

            if (successfulStored) {
                this.errors = errors;
            }

            if (errors === 'Unauthenticated.') {
                window.location.replace('/login');
                return;
            }

            return successfulStored;
        },

        /**
         * Reset errors on all inputs.
         */
        resetErrors() {
            for (var i = 0; i < this.allowedInputs.length; i++) {
                var allowedInput = this.allowedInputs[i];
                if (this.hasError(allowedInput)) {
                    this.errors[allowedInput] = '';
                }
            }
        },

        /**
         * Check if given input is allowed.
         * @param  string  input
         * @return bool
         */
        isAllowedInput(input) {
            return this.allowedInputs.indexOf(input) > -1;
        },

        /**
         * Check if there is at least one error.
         * @return bool
         */
        hasAtLeastOneError() {
            return this.errors.length > 0;
        },
    },
}

export default FormErrorsMixin;
